/*
 * Copyright (c) 2019
 *    Reliant Business Valuation, LLC - http://reliantvalue.com
 *    Author: Kirill Vizniuk - kirill@internalvaluation.com
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */


import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { RestResponse } from 'src/app/model';
import { SearchableProvider } from 'src/app/model/interface';
import { environment } from 'src/environments/environment';
import { ApiHeaders } from './headers';

@Injectable()
export class RoTProvider implements SearchableProvider {

  constructor(
    private http: HttpClient
  ) { }

  getRotList(page: number, query: string): Observable<RestResponse> {
    return this.http.
      get<RestResponse>(`${environment.API_URL}/api/bvq/rot/list?page=${page}` +
        (query ? '&query=' + encodeURIComponent(query) : ''),
        ApiHeaders.getOptions());
  }

  getById(id: string): Observable<RestResponse> {
    return this.http
      .get<RestResponse>(environment.API_URL + '/api/bvq/rot/' + id, ApiHeaders.getOptions());
  }

  postRot(data: FormData): Observable<any> {
    return this.http.post(`${environment.API_URL}/api/bvq/rot/rot-parse`, data);
  }

  save(id: string, field: string, value: any): Observable<RestResponse> {
    return undefined;
  }

  saveRotField(id: string, rot: string): Observable<RestResponse> {
    return this.http
      .post<RestResponse>(environment.API_URL + `/api/bvq/rot/${id}`, {
        FIELD: "ROT",
        VALUE: rot,
      }, ApiHeaders.getOptions());
  }

   /**Save ROT Field */
  saveRotFields(id: string, rotId: string, field: string, value: any): Observable<RestResponse> {
    return this.http
      .post<RestResponse>(`${environment.API_URL}/api/bvq/rot/${id}/field`, {
        FIELD: field,
        VALUE: value
      }, ApiHeaders.getOptions());
  }

  search(query?: string, id?: string, nonBank?: boolean, lsp?: boolean, page?: number): Observable<RestResponse> {
    return this.getRotList(page ? page : 1, query);
  }

  getSearchType(): string {
    return 'ROT';
  }
}
